import { FilterWidget, RankingListWidget } from '@widgets/main';

const Main = () => {
  return (
    <>
      <FilterWidget />
      <RankingListWidget />
    </>
  );
};

export default Main;
